export default __webpack_public_path__ + "static/media/R5koritu.29405363.mp3";